module.exports = __webpack_public_path__ + "418b1426199c44a46dd67da91ceaafa0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/monster_energy_company_2023_chart.png
// module id = 1697
// module chunks = 0